<template>
  <base-modal :box="box_init" :step="step">
    <z-form ref="form" @submit.native.prevent="save">
      <form-input-name v-model="form.name" :box_type="box.type" />

      <z-form-group v-show="form.params.time_condition_id" class="row">
        <z-form-input class="offset-4 col-8" :rules="{ required: true }" :show_errors="false">
          <template v-if="time_condition_loading">
            <spin fix size="large" />
          </template>

          <template v-else>
            <time-interval :item="time_condition" class="time-box__interval" />
          </template>
          <input v-model="form.params.time_condition_id" type="hidden" />
        </z-form-input>
      </z-form-group>

      <z-form-group class="row mb-2">
        <z-form-input class="offset-4 col-8">
          <i-button type="primary" size="large" icon="md-add" long @click="set_another_step">
            {{ button_title }}
          </i-button>
        </z-form-input>
        <z-form-input class="offset-4 col-8" :rules="{ required: true }" :show_errors="true">
          <input v-model="form.params.time_condition_id" type="hidden" />
        </z-form-input>
      </z-form-group>
    </z-form>

    <i-button
      slot="footer-ok"
      slot-scope="{ is_button_loading }"
      type="success"
      size="large"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('pbx.worksheet.modal.action.main.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import FormInputName from '../../../_base/_fragments/form-input-name';
  import TimeInterval from '@pbx/components/time-conditions/_fragments/time-condition/item-collapse';
  import { StepMixin } from '../../../_base/step-mixin';
  import { TimeConditionService } from '@pbx/services/TimeConditionService';
  import { WorkTimeService } from '@pbx/services/WorkTimeService';

  /**
   * props.box - автоматически прокидывается в form
   * чтобы сохранить состояние шага, используй mixin_save_step из StepMixin
   */

  export default {
    components: { BaseModal, FormInputName, TimeInterval },
    mixins: [StepMixin],

    data() {
      return {
        time_condition: {},
        time_condition_loading: true
      };
    },
    computed: {
      button_title: function() {
        const key = this.form.params.time_condition_id ? 'title_edit' : 'title';
        return this.$t(`pbx.worksheet.action.time.state.add_schedule.${key}`);
      }
    },

    created() {
      const id = this.form.params.time_condition_id;
      const requests = [TimeConditionService.getItem(id), WorkTimeService.getAll(id)];

      Promise.all(requests)
        .then(response => {
          const time_condition = response[0];
          const worktimes = response[1];

          this.time_condition = {
            ...time_condition,
            worktimes: worktimes
          };
        })
        .finally(() => (this.time_condition_loading = false));
    },

    methods: {
      save: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const box = this.mixin_get_box(this.form);
            this.$emit('on-save', box);
          }
        });
      },

      set_another_step() {
        this.mixin_save_step(this.form);
        this.mixin_set_step('add-schedule');
      }
    }
  };
</script>

<style lang="scss">
  .time-box {
    &__interval {
      border: none;
      .time-condition-collapse__content {
        margin-left: 0;
        margin-top: 5px;
      }
    }
  }
</style>
